import { render } from "./TungstenFabricTableView.vue?vue&type=template&id=5ff23e7c&scoped=true"
import script from "./TungstenFabricTableView.vue?vue&type=script&lang=js"
export * from "./TungstenFabricTableView.vue?vue&type=script&lang=js"

import "./TungstenFabricTableView.vue?vue&type=style&index=0&id=5ff23e7c&scoped=true&lang=less"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff23e7c"]])

export default __exports__